module.exports = __webpack_public_path__ + "img/report-2.38ea69d8.jpg";